import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_WorkHub } from '../../_module/index.js';
import './Component_WorkHubActionMenu.scss';
import { TS_Icons } from '@nu-art/ts-styles';
import { exists, generateHex, resolveContent } from '@nu-art/ts-common';
import { isWorkHubTabGroup } from '@nu-art/work-hub-shared';
export class Component_WorkHubActionMenu extends ComponentSync {
    // ######################## Static ########################
    static show = (e, props) => {
        const model = {
            id: 'work-hub-action-menu',
            content: () => _jsx(Component_WorkHubActionMenu, { ...props, originX: e.clientX }),
            originPos: { x: e.clientX, y: e.clientY },
            modalPos: { x: 1, y: 1 },
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    // ######################## Logic ########################
    generateGeneralSection = () => {
        const currentGroupKey = ModuleFE_WorkHub.group.getKeyForTabId(this.props.tabId);
        const availableGroups = ModuleFE_WorkHub.tabs.get().filter(i => isWorkHubTabGroup(i) && i.groupKey !== currentGroupKey);
        const actions = [
            { label: 'Close', action: () => ModuleFE_WorkHub.tabs.remove(this.props.tabId) },
            {
                label: 'Close Other Tabs',
                visible: ModuleFE_WorkHub.tabs.getFlat().length > 1,
                action: () => ModuleFE_WorkHub.tabs.getFlat()
                    .filter(tab => tab.id !== this.props.tabId)
                    .forEach(tab => ModuleFE_WorkHub.tabs.remove(tab.id)),
            },
            {
                label: 'Move to group',
                innerActions: [
                    {
                        label: 'New Tab Group',
                        separatorAfter: true,
                        action: () => ModuleFE_WorkHub.group.create(generateHex(4), this.props.tabId),
                    },
                    ...availableGroups.map(g => ({
                        label: g.label,
                        action: () => ModuleFE_WorkHub.group.addTabs(g.groupKey, [this.props.tabId]),
                    }))
                ],
            }
        ];
        if (currentGroupKey)
            actions.push({
                label: 'Remove from group',
                action: () => ModuleFE_WorkHub.tabs.removeFromGroup(this.props.tabId),
            });
        return { actions };
    };
    getSections = () => {
        return [
            this.generateGeneralSection(),
            ...(this.props.customSections ?? [])
        ];
    };
    closeMenu = () => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
    };
    hasVisibleActions = (item) => {
        if ('actions' in item)
            return item.actions.some(this.hasVisibleActions);
        if (exists(item.visible))
            return resolveContent(item.visible);
        return item.innerActions?.length ? item.innerActions.some(this.hasVisibleActions) : true;
    };
    // ######################## Render ########################
    render() {
        const sections = this.getSections();
        return sections.map(this.render_Section);
    }
    render_Section = (section, index) => {
        if (!this.hasVisibleActions(section))
            return;
        return _jsxs(LL_V_L, { className: 'action-menu__section', children: [!!section.label?.length && _jsx("div", { className: 'action-menu__section-label', children: section.label }), section.actions.map(this.render_Action)] }, index);
    };
    render_Action = (action, index) => {
        if (!this.hasVisibleActions(action))
            return;
        if (action.action)
            return this.render_ActionButton(action, index);
        return this.render_ActionWithInner(action, index);
    };
    render_ActionButton = (action, index) => {
        const visible = resolveContent(action.visible);
        if (exists(visible) && !visible)
            return;
        const disabled = resolveContent(action.disabled);
        return _jsxs(Fragment, { children: [_jsx(Button, { variant: 'work-hub-menu-action', disabled: disabled, onClick: async () => {
                        await action.action();
                        this.closeMenu();
                    }, children: action.label }), action.separatorAfter && _jsx("div", { className: 'action-menu__separator' })] }, index);
    };
    shouldFlipSubmenus = () => {
        const menuWidth = 300;
        const submenuWidth = 310;
        return (this.props.originX ?? 0) + menuWidth + submenuWidth > window.innerWidth;
    };
    render_ActionWithInner = (action, index) => {
        const hasInner = !!action.innerActions?.length;
        const renderInner = hasInner && !action.disabled;
        const anchorId = generateHex(4);
        const style = { '--anchor-id': anchorId };
        const className = _className('work-hub-menu-action-with-inner', action.disabled && 'disabled', this.shouldFlipSubmenus() && 'flip-left');
        return _jsxs("div", { className: className, style: style, children: [_jsxs(LL_H_C, { className: 'work-hub-menu-action', children: [_jsx("div", { className: 'work-hub-menu-action__label', children: action.label }), hasInner && _jsx(TS_Icons.treeCollapse.component, {})] }), action.separatorAfter && _jsx("div", { className: 'action-menu__separator' }), renderInner && _jsx(LL_V_L, { className: 'work-hub-menu-action__inner-actions', children: action.innerActions?.map(this.render_Action) })] }, index);
    };
}
//# sourceMappingURL=Component_WorkHubActionMenu.js.map